import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-document-warning",
  "use": "icon-si-glyph-document-warning-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-document-warning\" id=\"icon-si-glyph-document-warning\"><title>148</title><defs class=\"\"></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(3.000000, 0.000000)\" fill=\"#434343\"><g><path d=\"M7.031,0.031 L7.031,3.969 L10.902,3.969 L7.031,0.031 Z\" class=\"si-glyph-fill\" /><path d=\"M5.99427606,0 L0.042,0 L0.042,16 L11.042,16 L11.042,5 L5.99427606,5.06446531 L5.99427606,0 Z M1.958,13 L5.43785965,6 L8.958,13 L1.958,13 Z\" class=\"si-glyph-fill\" /></g><path d=\"M5,8 L5,10.0153198 L5.97741699,10.0153198 L5.97741699,8 L5,8 Z\" class=\"si-glyph-fill\" /><rect x=\"5\" y=\"11\" width=\"0.875\" height=\"1\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-document-warning.svg
// module id = ZoBt
// module chunks = 62